import configs from '@/configs';

export const PERMISSION_FEATURES = [
  { key: 'logging', label: 'Nhật ký hệ thống' },
  { key: 'customer', label: 'Khách hàng' },
  { key: 'payment_pending', label: 'Chờ thanh toán' },
  { key: 'payment_history', label: 'Lịch sử thanh toán' },
  { key: 'store_cn', label: 'Nhập kho TQ' },
  { key: 'store_vn', label: 'Nhập kho VN' },
  { key: 'small_package', label: 'Mã vận đơn' },
  { key: 'noname', label: 'Không tên' },
  { key: 'big_package', label: 'Bao hàng' },
  { key: 'export_receipt', label: 'Yêu cầu giao hàng' },
  { key: 'tmdt_sales_dashboard', label: 'BC Sale TMĐT' },
  { key: 'bao_cao_bao_hang', label: 'BC Bao hàng TMĐT' },
  { key: 'bao_cao_xuat_hang', label: 'BC Xuất hàng TMĐT' },
  { key: 'wuliu_list', label: 'Nhập kho lô TQ' },
  { key: 'unnamed_package', label: 'Hàng không tên' },
  { key: 'batch_package_all', label: 'QL Mã bốc' },
  { key: 'truck_list', label: 'QL Xe' },
  { key: 'bill_list', label: 'Xuất kho lô' },
  { key: 'sales_dashboard', label: 'BC Sale lô' },
  { key: 'storage_by_batch_code_report', label: 'BC Lưu kho lô' },
  { key: 'cn_service', label: 'Thiết lập dịch vụ CN' },
  { key: 'cn_order', label: 'Quản lý đơn hàng CN' },
  { key: 'cn_truck', label: 'Quản lý khai báo CN' },
  { key: 'cn_delivery', label: 'Giao hàng CN' },
  { key: 'cn_payment', label: 'Quản lý tài chính CN' },
  { key: 'cn_report', label: 'BC Sale CN' },
  { key: 'overview', label: 'Tổng quan' },
  { key: 'setting', label: 'Cài đặt' }
];

export function buildPermissionTemplate(roles = configs.ROLES) {
  const template = {};
  PERMISSION_FEATURES.forEach(feature => {
    template[feature.key] = {};
    roles.forEach(role => {
      template[feature.key][role.value] = 0;
    });
  });
  return template;
}

export function normalizePermissionMatrix(remoteMatrix, roles = configs.ROLES) {
  const matrix = buildPermissionTemplate(roles);
  if (!remoteMatrix || typeof remoteMatrix !== 'object') {
    return matrix;
  }
  PERMISSION_FEATURES.forEach(feature => {
    const roleMap = remoteMatrix[feature.key];
    if (!roleMap || typeof roleMap !== 'object') {
      return;
    }
    roles.forEach(role => {
      const candidates = [role.value, role.value.toString()];
      let rawValue;
      for (let i = 0; i < candidates.length; i += 1) {
        const key = candidates[i];
        if (Object.prototype.hasOwnProperty.call(roleMap, key)) {
          rawValue = roleMap[key];
          break;
        }
      }
      matrix[feature.key][role.value] = normalizePermissionValue(rawValue);
    });
  });
  return matrix;
}

export function normalizePermissionValue(value) {
  const numeric = Number(value);
  return [0, 1, 2].includes(numeric) ? numeric : 0;
}
